import { Injectable } from '@angular/core';
import {SessionService} from "./session.service";

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private sessionService: SessionService
              ) { }

  Init() {
    return new Promise<void>((resolve) => {
      setTimeout(async () => {
        const user = await this.sessionService.doAuth();
        if (!user) {
          console.log('login');
          resolve();
        }
        resolve();
      }, 200);
    })
  }
}
